import addMount from "../../core/addMount";
import PatronPage from "./PatronPage.entry";

addMount({ appName: "patron-page", app: PatronPage });
